import { Button, Stack, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export type TransactionListPaginationProps = {
  /// 1-based page number.
  page: number;
  hasPrevious: boolean;
  hasNext: boolean;
  /// How many rows the current page holds — used for the "showing N" caption.
  rowCount: number;
  onPrevious: () => void;
  onNext: () => void;
};

/**
 * Previous/Next control for the cursor-paged transaction list. The API has no
 * total count, so there is no "page 2 of 7" — only whether a further page
 * exists (`hasNext`, from the response's `hasMore`).
 */
export const TransactionListPagination = ({
  page,
  hasPrevious,
  hasNext,
  rowCount,
  onPrevious,
  onNext,
}: TransactionListPaginationProps) => {
  if (!hasPrevious && !hasNext) return null;

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ alignItems: "center", justifyContent: "flex-end", mt: 2 }}
    >
      <Typography variant="body2" sx={{ color: "text.secondary", mr: 1 }}>
        Page {page} · {rowCount} {rowCount === 1 ? "row" : "rows"}
      </Typography>
      <Button
        size="small"
        startIcon={<ChevronLeftIcon />}
        disabled={!hasPrevious}
        onClick={onPrevious}
      >
        Previous
      </Button>
      <Button
        size="small"
        endIcon={<ChevronRightIcon />}
        disabled={!hasNext}
        onClick={onNext}
      >
        Next
      </Button>
    </Stack>
  );
};
